import { supabase } from '@/integrations/supabase/client';

export async function triggerJobSync() {
  try {
    console.log('Triggering job sync...');
    
    const { data, error } = await supabase.functions.invoke('sync-coveto-jobs', {
      body: {}
    });

    if (error) {
      console.error('Sync error:', error);
      throw error;
    }

    console.log('Sync result:', data);
    return data;
  } catch (error) {
    console.error('Failed to trigger sync:', error);
    throw error;
  }
}
